const styles = theme => ({
    CellSizeController:{
        position: 'absolute',
        right: 2*theme.spacing.unit,
        bottom: theme.spacing.unit,
        backgroundColor: 'rgba(255, 255, 255,1)',
        padding: theme.spacing.unit,
        borderRadius: '20px'
    },
    cellSizeTextField:{

    },
    lightTooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    }
});

export default styles;